import Vue from 'vue';
import ImageViewer from './component/index.vue';

const ImageViewerComponent = Vue.extend(ImageViewer);

const  $ImageViewer = {
  show(config) {
    const el: any = new ImageViewerComponent().$mount();
    el.imgVisible = true;
    el.imgArr = [config.current];
    document.body.appendChild(el.$el);
  },
};

export default {
  install() {
    if (!Vue.prototype.$ImageViewer) {
      Vue.prototype.$ImageViewer = $ImageViewer;
    }
  },
};
